module.exports = __webpack_public_path__ + "img/USERS.9f65c457.svg";